(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pv-cta-section"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('click', e => {
  const a = e.target.closest('a[data-pv-scroll]');
  if (!a) return;
  const href = a.getAttribute('href');
  if (href && href.startsWith('#')) {
    const target = document.querySelector(href);
    if (target) {
      e.preventDefault();
      target.scrollIntoView({behavior:'smooth', block:'start'});
    }
  }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pv-flavours-slider"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('.pv-flavours__viewport:not([data-init])').forEach(wrap => {
  wrap.dataset.init='1';
  const track = wrap.querySelector('.pv-flavours__track');
  const prev = wrap.querySelector('.pv-flavours__nav--prev');
  const next = wrap.querySelector('.pv-flavours__nav--next');
  function step(d){const t=track.querySelector('.pv-flavours__tile');if(!t)return;const w=t.getBoundingClientRect().width;const g=parseFloat(getComputedStyle(track).columnGap)||0;track.scrollBy({left:d*(w+g)*2,behavior:'smooth'});}
  prev&&prev.addEventListener('click',()=>step(-1));
  next&&next.addEventListener('click',()=>step(1));
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pv-occasions-grid"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('.pv-occasions__viewport:not([data-init])').forEach(wrap => {
  wrap.dataset.init='1';
  const track = wrap.querySelector('.pv-occasions__track');
  const prev = wrap.querySelector('.pv-occasions__nav--prev');
  const next = wrap.querySelector('.pv-occasions__nav--next');
  function step(d){const t=track.querySelector('.pv-occasions__tile');if(!t)return;const w=t.getBoundingClientRect().width;const g=parseFloat(getComputedStyle(track).columnGap)||0;track.scrollBy({left:d*(w+g)*2,behavior:'smooth'});}
  prev&&prev.addEventListener('click',()=>step(-1));
  next&&next.addEventListener('click',()=>step(1));
});

  } catch(e) { console.error(e); }
})();
})();
